import React, { useEffect,useState, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Formik } from "formik";
import { Input } from "legacy_components/Input";
import { AutocompleteSelect } from "legacy_components/AutocompleteSelect";
import { FieldsWrapper } from "legacy_components/FieldsWrapper";
//import { DatePicker } from "legacy_components/DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "legacy_css_modules/Stats.module.css";

import headStyles from 'legacy_css_modules/DocumentList.module.css';

import {request} from 'helpers/tools';
import {ProgressSpinner} from 'legacy_components/ProgressSpinner';
import {Button} from 'legacy_components/Button';
export const Stats =  ({ user }) => {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [dateFrom, setDateFrom] = useState(firstDayOfMonth);
  const [dateTo, setDateTo] = useState(today);
  
  const [selectedClientCompanyId, setSelectedClientCompanyId] = useState(-1);
  const [selectedAccountingCompanyId, setSelectedAccountingCompanyId] = useState(user.company_id);

  const [timePeriod, setTimePeriod] = useState("day"); 
  const [statsB, setStatsB] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [totalSums, setTotalSums] = useState([]);
  const [statsPosted, setStatsPosted] = useState(false);
  const [busy, setBusy] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const [fastStats, setFastStats] = useState(false);
  const latestRequestRef = useRef(0);

    const currency = user.company_country_slug === "cz" ? "Kč" :"EUR"
    
const handleYearChange = (option) => {
  const newYear = option;
  setSelectedYear(newYear)
  if (selectedMonth) {
    const firstDay = new Date(newYear, selectedMonth - 1, 1);
    const lastDay = new Date(newYear, selectedMonth, 0);
    handleChangeDateFrom(firstDay);
    handleChangeDateTo(lastDay);
  }
};

const handleMonthChange = (option) => {
  const newMonth = option;
  setSelectedMonth(newMonth);

  if (selectedYear) {
    let firstDay = undefined
    let lastDay = undefined
    if (newMonth === 0){
      firstDay = new Date(selectedYear, 0, 1);
      firstDay.setHours(3, 0, 0, 0);
      lastDay = new Date(selectedYear, 11, 32);   
      lastDay.setHours(3, 0, 0, 0); 
    }
    else{
      firstDay = new Date(selectedYear, newMonth - 1, 1);
      firstDay.setHours(3, 0, 0, 0);
      lastDay = new Date(selectedYear, newMonth, 0);
      lastDay.setHours(3, 0, 0, 0);
    }

    handleChangeDateFrom(firstDay);
    handleChangeDateTo(lastDay);
  }
};


const colors = [
  "#8884d8", "#82ca9d", "#ffc658", "#d84b8a", "#ff8042",
  "#8dd1e1", "#a4de6c", "#ffbb28", "#6495ed", "#ff69b4",
  "#ba55d3", "#cd5c5c", "#20b2aa", "#32cd32", "#daa520"
];
    
  useEffect(() => {
  const getStats = async () => {
    const requestId = ++latestRequestRef.current;

    let url = '/get_accounting_company_stats/';
    const data = {
      user: user.pk,
      year: selectedYear,
      month: selectedMonth,
      accounting_company: selectedAccountingCompanyId,
      fast: fastStats
    };

    console.log("Requested", selectedYear, "month", selectedMonth);

    const response = await request(url, 'POST', JSON.stringify(data));

    
    if (requestId !== latestRequestRef.current) {
      return; 
    }

    if (response.body) {
      console.log("Accepted", response.body.year, response.body.month);

      setStatsB(response.body.stats);
      setPricing(response.body.pricing);
      setTotalSums(response.body.totals);
      setStatsPosted(true);
    }
  };

  getStats();
}, [
  user.pk,
  selectedAccountingCompanyId,
  selectedYear,
  selectedMonth,
  fastStats
]);


const filteredCompanies = Object.keys(totalSums)
  .filter(key => key !== "all")
  .map(key => ({
    title: key,
    id: totalSums[key].id
  }));


  const companiesWithIds = [
    { id: -1, title: "Všechny společnosti" },
    ...filteredCompanies.map((company) => ({
      id: company.id,
      title: company.title,
    })),
  ];
  
  const accountingCompaniesWithIds = [
    //{ id: -1, title: "Všechny společnosti" },
    ...user.master_docspoint_accounting_companies.map((company) => ({
      id: company.id,
      title: company.title,
    })),
  ];
  
  const filterDataByMetric = (data, selectedMetric) => {
    return data.map((entry) => {
      const filteredEntry = { day: entry.day };

      Object.keys(entry).forEach((key) => {
        if (key !== "day") {
          filteredEntry[key] = entry[key][selectedMetric];
        }
      });

      return filteredEntry;
    });
  };
const extractCompanyData = (data, companyId) => {
  if (!data) return [];

  const company = filteredCompanies.find((c) => c.id === companyId);
  if (!company) return []

  const companyName = company.title;

  return data.map((entry) => {
    const companyEntry = entry[companyName];
    return {
      day: entry.day,
      documents: companyEntry?.documents ?? null,
      documentsCaptured: companyEntry?.documentsCaptured ?? null,
      documentsSynchronized: companyEntry?.documentsSynchronized ?? null,
      pagesCaptured: companyEntry?.pagesCaptured ?? null,
      files: companyEntry?.files ?? null,
      attachments: companyEntry?.attachments ?? null
    };
  });
};

const summarizeCompanyDocuments = (data) => {
  if (!data || !user || !filteredCompanies) return [];

  const summary = filteredCompanies.map((company) => {
    const entries = extractCompanyData(data, company.id);
    const companySum = entries.reduce(
      (acc, entry) => {
        
        acc.documents += entry.documents ?? 0;
        acc.documentsCaptured += entry.documentsCaptured ?? 0;
        acc.documentsSynchronized += entry.documentsSynchronized ?? 0;
        acc.pagesCaptured += entry.pagesCaptured ?? 0;
        acc.files += entry.files ?? 0;
        acc.attachments += entry.attachments ?? 0;

        return acc;
      },
      {
        documents: 0,
        documentsCaptured: 0,
        documentsSynchronized: 0,
        pagesCaptured: 0,
        files: 0,
        attachments: 0,
      }
    );

    return {
      companyId: company.id,
      companyTitle: company.title,
      totalCosts: isNaN(parseFloat(pricing?.client_companies_costs?.[company.id])) ? 0 : parseFloat(pricing.client_companies_costs[company.id]),
      totalRossum: isNaN(parseFloat(pricing?.client_companies_rossum?.[company.id])) ? 0 : parseFloat(pricing.client_companies_rossum[company.id]),
      ...companySum,
    };
  });
  const total = summary.reduce(
    (acc, company) => {
      acc.totalDocuments += company.documents;
      acc.totalCaptured += company.documentsCaptured;
      acc.totalSynchronized += company.documentsSynchronized;
      acc.totalPagesCaptured += company.pagesCaptured;
      acc.totalFiles += company.files;
      acc.totalAttachments += company.attachments;
      acc.totalCosts += company.totalCosts
      acc.totalRossum += company.totalRossum
      return acc;
    },
    {
      totalDocuments: 0,
      totalCaptured: 0,
      totalSynchronized: 0,
      totalPagesCaptured: 0,
      totalFiles: 0,
      totalAttachments: 0,
      totalCosts: 0,
      totalRossum: 0,
    }
  );

   return {
    companies: summary,
    totals: total
  };
};

  const rawData = statsB;

  let metricData = filterDataByMetric(rawData, "documents");

  let companyData = extractCompanyData(rawData, selectedClientCompanyId);

  
  metricData = metricData.filter((entry) => {
    const entryDate = new Date(entry.day);
    return entryDate >= dateFrom && entryDate <= dateTo;
  });

  companyData = companyData.filter((entry) => {
    const entryDate = new Date(entry.day);
    return entryDate >= dateFrom && entryDate <= dateTo;
  });

  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate() < 10 ? '0' : ''}${d.getDate()}/${d.getMonth() + 1 < 10 ? '0' : ''}${d.getMonth() + 1}`;
  };

  

  const groupData = (total=false) => {
    const groupedData = {};
    if (selectedClientCompanyId===-1 || total ===true){
        metricData.forEach((entry) => {
        const date = new Date(entry.day);
        let key = "";

        if (timePeriod === "day") {
          key = formatDate(date);
        } else if (timePeriod === "week") {
          const startOfWeek = new Date(date);
          const dayOfWeek = startOfWeek.getDay();
          startOfWeek.setDate(date.getDate() - dayOfWeek+1);

          const endOfWeek = new Date(startOfWeek);
          endOfWeek.setDate(startOfWeek.getDate() + 7);

          key = `${formatDate(startOfWeek)}-${formatDate(endOfWeek)}`;
        } else if (timePeriod === "month") {
          key = `${date.getMonth() + 1}-${date.getFullYear()}`;
        } else if (timePeriod === "year") {
          key = `${date.getFullYear()}`;
        }

        if (!groupedData[key]) {
          groupedData[key] = { day: key };
        }

        filteredCompanies.forEach((company) => {
          const companyName = company.title;
          groupedData[key][companyName] =
            (groupedData[key][companyName] || 0) + (entry[companyName] || 0);
        });
      });
    }
    else{
      companyData.forEach((entry) => {
      const date = new Date(entry.day)
      let key = "";

      if (timePeriod === "day") {
        key = formatDate(date);
      } else if (timePeriod === "week") {
        const startOfWeek = new Date(date);
        const dayOfWeek = startOfWeek.getDay();
        startOfWeek.setDate(date.getDate() - dayOfWeek);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        key = `${formatDate(startOfWeek)}-${formatDate(endOfWeek)}`;
      } else if (timePeriod === "month") {
        key = `${date.getMonth() + 1}-${date.getFullYear()}`;
      } else if (timePeriod === "year") {
        key = `${date.getFullYear()}`;
      }

      if (!groupedData[key]) {
        groupedData[key] = { day: key };
      }

      ["documents","documentsCaptured"].forEach((company) => {
        const companyName = company
        groupedData[key][companyName] =
          (groupedData[key][companyName] || 0) + (entry[companyName] || 0);
      });
    });
    }

    return Object.values(groupedData);
  };

  const finalData = groupData();

  const handleClientCompanySelection = (e) => {
    setSelectedClientCompanyId(e);
  };

  const handleAccountingCompanySelection = (e) => {
    setSelectedAccountingCompanyId(e);
    handleMonthChange(selectedMonth)
  };

  const handleChangeDateFrom = (event) => {
    setDateFrom(event);
    setStatsB([])
    setStatsPosted(false)
  };

  const handleChangeDateTo = (event) => {
    setStatsB([])
    setDateTo(event);
    setStatsPosted(false)
    };

  const handleTimePeriodChange = (e) => {
    setTimePeriod(e.target.value);
  };

  const { companies, totals } = summarizeCompanyDocuments(rawData);

const ccHeadStyle = {
  padding: '0.5rem',
  textAlign: 'left',
  verticalAlign: 'bottom',
  fontSize: '0.8rem',
  fontWeight: "bold",
  backgroundColor: 'white',
  borderBottom: '4px solid rgba(217, 130, 200, 1)',
  minWidth: '10rem',
  maxWidth: '10rem'

};

const headStyle = {
  padding: '0.5rem',
  textAlign: 'center',
  verticalAlign: 'bottom',
  fontSize: '0.8rem',
  fontWeight: "bold",
  width: '4rem',
  backgroundColor: 'white',
  borderBottom: '4px solid rgba(217, 130, 200, 1)'
};



  const bodyStyle = {
    padding: '0.5rem', 
    border: '0px solid black',
    fontSize: '0.8rem',
    marginLeft: '10px',
    borderRadius: '1px', 
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textAlign: "right",
    maxWidth: '10rem'
    };

    function download(blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = "stats_export.ods"
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        setBusy(false)
      }
      
  async function downloadStats () {
    setBusy(true)
    fetch(`${process.env.REACT_APP_API}/get_accounting_company_stats_ods/?user=${user.pk}&year=${selectedYear}&month=${selectedMonth}&company=${selectedAccountingCompanyId}&fast=${fastStats}`, {
            method: 'GET',
            headers: {
                'Authorization': 'JWT ' + localStorage.getItem('DocspointJWT')
            }
          }).then((response) => {
            response.blob().then(blob => download(blob))})
  }
  
  const years = Array.from({ length: 3 }, (_, i) => {
  const year = new Date().getFullYear() - i;
    return { title: `${year}`, id: year };
  });

  const months = [
    //{ title: 'Celý rok', id: 0 },
    { title: 'Leden', id: 1 },
    { title: 'Únor', id: 2 },
    { title: 'Březen', id: 3 },
    { title: 'Duben', id: 4 },
    { title: 'Květen', id: 5 },
    { title: 'Červen', id: 6 },
    { title: 'Červenec', id: 7 },
    { title: 'Srpen', id: 8 },
    { title: 'Září', id: 9 },
    { title: 'Říjen', id: 10 },
    { title: 'Listopad', id: 11 },
    { title: 'Prosinec', id: 12 },
  ];
const CustomTooltip = ({ active, payload, label, coordinate }) => {
  if (active && payload && payload.length) {
    const maxNameLength = 20;
    const maxEntriesHeight = 400;

    // Keep only non-zero items
    const nonZeroPayload = payload.filter(p => p.value !== 0);
    if (nonZeroPayload.length === 0) return null;

    const useTwoColumns = nonZeroPayload.length > 10;
    let leftColumn = nonZeroPayload;
    let rightColumn = [];

    if (useTwoColumns) {
      const half = Math.ceil(nonZeroPayload.length / 2);
      leftColumn = nonZeroPayload.slice(0, half);
      rightColumn = nonZeroPayload.slice(half);
    }

    return (
      <div
        style={{
          position: 'absolute',
          left: coordinate.x,
          top: coordinate.y + 10,
          backgroundColor: 'white',
          border: '1px solid #ccc',
          padding: '5px',
          maxWidth: useTwoColumns ? '20rem' : '12rem',
          maxHeight: maxEntriesHeight,
          overflowY: 'auto',
          overflowX: 'hidden',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          borderRadius: '4px',
          pointerEvents: 'auto',
        }}
      >
        <p
          style={{
            margin: 0,
            fontWeight: 'bold',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label.length > maxNameLength ? label.slice(0, maxNameLength) + '…' : label}
        </p>
        <div style={{ display: 'flex', marginTop: '5px' }}>
          <div style={{ flex: 1, marginRight: useTwoColumns ? '5px' : '0' }}>
            {leftColumn.map((p, idx) => (
              <p
                key={idx}
                style={{
                  color: p.color,
                  margin: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {p.name.length > maxNameLength ? p.name.slice(0, maxNameLength) + '…' : p.name}: {p.value}
              </p>
            ))}
          </div>
          {useTwoColumns && (
            <div style={{ flex: 1 }}>
              {rightColumn.map((p, idx) => (
                <p
                  key={idx + leftColumn.length}
                  style={{
                    color: p.color,
                    margin: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {p.name.length > maxNameLength ? p.name.slice(0, maxNameLength) + '…' : p.name}: {p.value}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
  return null;
};




function formatPrice(value, decimals = 2) {
  if (value == null || isNaN(value)) return '';
  
  const parts = value.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  return parts.join('.');
}


  return (

  <div style={{overflowY: "auto", height:"92vh"}}>
    <header className={headStyles.topRow}>
      <h1 className={headStyles.heading}>Statistiky účetní společnosti</h1>
    </header>

    <div className={styles.container}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Formik initialValues={{}}>
          {() => (
            <FieldsWrapper columns={2}>
              <Input
                name="year"
                component={AutocompleteSelect}
                data={years}
                selectedValue={selectedYear}
                onChange={handleYearChange}
                className={styles.input}
                noErrorPlaceholder
                noBlankOption
              >
                Rok
              </Input>
              <Input
                name="month"
                component={AutocompleteSelect}
                data={months}
                selectedValue={selectedMonth}
                onChange={handleMonthChange}
                className={styles.input}
                noErrorPlaceholder
                noBlankOption
              >
                Měsíc
              </Input>
            </FieldsWrapper>
          )}
        </Formik>
          <div style={{ textAlign: 'center', color:"gray"}}>
            {user.master_docspoint_admin===true &&<>
                  <Formik initialValues={{}}>
                    {() => (
                      <Input
                        name="accounting_companies"
                        component={AutocompleteSelect}
                        data={accountingCompaniesWithIds}
                        selectedValue={selectedAccountingCompanyId}
                        onChange={handleAccountingCompanySelection}
                        className={styles.input}
                        noBlankOption
                        noErrorPlaceholder
                      >
                        Účetní společnost
                        </Input>  
                    )}
                  </Formik>
               <input
                  type="checkbox"
                  checked={fastStats}
                  onChange={() => {
                    setFastStats(!fastStats);
                    setStatsPosted(false);
                  }}
                   style={{ marginRight: "6px" }}
                />

               Fast stats
                </>
            }
          </div>
        <div style={{ marginTop: "2rem" }}>
          {statsPosted === true && (
            <Button disabled={busy} onClick={downloadStats}>
              {busy ? "Generuji data..." : "Stáhnout statistiky"}
            </Button>
          )}
        </div>
      </div>

      {statsPosted === false && <ProgressSpinner />}

      {statsPosted === true && (
        <div style={{ display: "grid", gridTemplateColumns: "40rem 1fr", gap: "2rem", width: "100%" }}>
          <div>
            <h2 style={{  marginTop: "2rem", marginBottom:"-0.1rem"}}>Přehled zpracovaných dokladů</h2>
            <table
                        border="0"
                        style={{
                          borderCollapse: "separate",
                          borderRadius: "1px",
                          display: "table",
                          width: "auto",
                          marginBottom: "2rem"
                        }}
                      >
                        <tbody style={{ display: "table-row-group" }}>
                          <tr
                            style={{
                              position: 'sticky',
                              top: 0,
                              backgroundColor: 'var(--primarylight)',
                              height: '40px',
                              zIndex: 10,
                              display: 'table-row',
                            }}
                          >
                            <td style={ccHeadStyle}>Klientská společnost</td>
                            <td style={headStyle}>Doklady</td>
                            {/*<td style={headStyle}>Soubory</td>
                            <td style={headStyle}>Přílohy</td>*/}
                            <td title="Doklady synchronizované do Docspointu" style={headStyle}>
                              Synchron.
                            </td>
                            <td style={headStyle}>Vytěženo dokladů</td>
                            <td style={headStyle}>Vytěženo stran</td>
                          </tr>

                          {companies.map((company, idx) => (
                            <tr key={idx} className={styles.dataRow}>
                              <td style={{ ...bodyStyle, overflow: "hidden", textAlign:"left",textOverflow: "ellipsis" }} title={company.companyTitle}>
                                {company.companyTitle}
                              </td>
                              <td style={bodyStyle}>{totalSums[company.companyTitle].documents}</td>
                              {/*<td style={bodyStyle}>{totalSums[company.companyTitle].files}</td>
                              <td style={bodyStyle}>{totalSums[company.companyTitle].attachments}</td>*/}
                              <td style={bodyStyle}>{totalSums[company.companyTitle].documentsSynchronized}</td>
                              <td style={bodyStyle}>{totalSums[company.companyTitle].documentsCaptured}</td>
                              <td style={bodyStyle}>{totalSums[company.companyTitle].pagesCaptured}</td>
                            </tr>
                          ))}

                          <tr className={styles.footRow}>
                            <td style={{ ...bodyStyle, overflow: "hidden", textAlign:"left", whiteSpace: "nowrap",textOverflow: "ellipsis" }}>Celkem</td>
                            <td style={bodyStyle}>{totals.totalDocuments}</td>
                            {/*<td style={bodyStyle}>{totals.totalFiles}</td>
                            <td style={bodyStyle}>{totals.totalAttachments}</td>*/}
                            <td style={bodyStyle}>{totals.totalSynchronized}</td>
                            <td style={bodyStyle}>{totals.totalCaptured}</td>
                            <td style={bodyStyle}>{totals.totalPagesCaptured}</td>
                          </tr>
                        </tbody>
                      </table>

                      <h2 style={{marginBottom:"-0.1rem"}}>Přehled uživatelských rolí</h2>
                      <table
                        border="0"
                        style={{
                          borderCollapse: "separate",
                          borderRadius: "1px",
                          display: "table",
                          marginBottom: "2rem",
                        }}
                      >
                        <tbody style={{ display: "table-row-group" }}>
                          <tr
                            style={{
                              position: 'sticky',
                              top: 0,
                              backgroundColor: 'var(--primarylight)',
                              height: '40px',
                              zIndex: 10,
                              display: 'table-row',
                            }}
                          >
                            <td style={ccHeadStyle}>Klientská společnost</td>
                            <td style={headStyle}>Základní</td>
                            <td style={headStyle}>Obslužný</td>
                            <td style={headStyle}>Schvalovací</td>
                            <td style={headStyle}>Účetní</td>
                            <td style={headStyle}>Využito uživ.&nbsp;účtů</td>
                          </tr>

                          {companies.map((company, idx) => {
                            const stats = pricing.client_company_user_stats[company.companyId] || {};
                            const getCell = (role) => {
                              const data = stats[role];
                              if (!data) return <td style={bodyStyle}><span style={{ color: "#999" }}>–</span></td>;
                              return (
                                <td style={bodyStyle}>
                                  {data.total}
                                  {data.shared > 0 && (
                                    <span style={{ fontSize: "0.8em", color: "#666" }}>
                                      {' '}({data.shared} sdílených)
                                    </span>
                                  )}
                                </td>
                              );
                            };

                            return (
                              <tr key={idx} className={styles.dataRow}>
                                <td style={{ ...bodyStyle, overflow: "hidden", textAlign:"left", textOverflow: "ellipsis" }} title={company.companyTitle}>
                                  {company.companyTitle}
                                </td>
                                {getCell("client")}
                                {getCell("maintenance")}
                                {getCell("manager")}
                                {getCell("accountant")}
                                <td style={bodyStyle}>{pricing.client_companies_user_score[company.companyId]}</td>
                              </tr>
                            );
                          })}

                          {/* --- Summary row --- */}
                          <tr className={styles.footRow}>
                            <td style={{ ...bodyStyle, overflow: "hidden", textAlign: "left", textOverflow: "ellipsis" }}>
                              Celkem
                            </td>

                            <td style={bodyStyle}>
                              {Math.round(
                                companies.reduce(
                                  (sum, c) =>
                                    sum + (pricing.client_company_user_stats[c.companyId]?.client?.total || 0),
                                  0
                                )
                              )}
                            </td>

                            <td style={bodyStyle}>
                              {Math.round(
                                companies.reduce(
                                  (sum, c) =>
                                    sum + (pricing.client_company_user_stats[c.companyId]?.maintenance?.total || 0),
                                  0
                                )
                              )}
                            </td>

                            <td style={bodyStyle}>
                              {Math.round(
                                companies.reduce(
                                  (sum, c) =>
                                    sum + (pricing.client_company_user_stats[c.companyId]?.manager?.total || 0),
                                  0
                                )
                              )}
                            </td>

                            <td style={bodyStyle}>
                              {Math.round(
                                companies.reduce(
                                  (sum, c) =>
                                    sum + (pricing.client_company_user_stats[c.companyId]?.accountant?.total || 0),
                                  0
                                )
                              )}
                            </td>

                            <td style={bodyStyle}>
                              {Math.round(
                                companies.reduce(
                                  (sum, c) =>
                                    sum + (pricing.client_companies_user_score[c.companyId] || 0),
                                  0
                                )
                              )}
                            </td>
                          </tr>

                        </tbody>
                      </table>


            <h2 >Přehled nákladů</h2>
             <table
                        border="0"
                        style={{
                          borderCollapse: "separate",
                          borderRadius: "1px",
                          display: "table",
                          width: "auto",
                        }}
                      >
                        <tbody style={{ display: "table-row-group" }}>
                          <tr
                            style={{
                              position: 'sticky',
                              top: 0,
                              backgroundColor: 'var(--primarylight)',
                              height: '40px',
                              zIndex: 10,
                              display: 'table-row',
                            }}
                          >
                            <td style={ccHeadStyle}>Klientská společnost</td>
                            <td style={headStyle}>Paušál</td>
                            <td
                              title={'Cena za zpracovaný doklad: ' + pricing["per_document"] + ' ' + currency}
                              style={headStyle}
                            >
                              Doklady
                            </td>
                            <td
                              title={'Cena za vytěžený doklad: ' + pricing["rossum"] + ' ' + currency}
                              style={headStyle}
                            >
                              Vytěžování
                            </td>
                            <td style={headStyle}>Celkem</td>
                          </tr>

                          {companies.map((company, idx) => (
                            <tr key={idx} className={styles.dataRow}>
                              <td style={{ ...bodyStyle, overflow: "hidden", textAlign:"left",textOverflow: "ellipsis" }}  title={company.companyTitle}>
                                  {company.companyTitle}
                                </td>
                              <td style={bodyStyle}
                                  title={
                                    'Účetní jednotka: ' + pricing["client_company_price"] + ' ' + currency + '\n' +
                                    'Uživatelské účty: ' + pricing.client_companies_user_score[company.companyId] + '×' + pricing["user_price"] + ' ' + currency
                                  }>
                                {formatPrice(pricing["client_companies_users"][company.companyId])} {currency}
                              </td>
                              <td style={bodyStyle}>
                                {formatPrice(pricing["client_companies_documents"][company.companyId])} {currency}
                              </td>
                              <td style={bodyStyle}>
                                {formatPrice(pricing["client_companies_rossum"][company.companyId])} {currency}
                              </td>
                              <td style={bodyStyle}>
                                {formatPrice(pricing["client_companies_total"][company.companyId])} {currency}
                              </td>
                            </tr>
                          ))}

                          <tr className={styles.footRow}>
                            <td style={{ ...bodyStyle, overflow: "hidden", textAlign:"left",textOverflow: "ellipsis" }}>Celkem</td>
                            <td style={bodyStyle}>
                              {formatPrice(pricing["accounting_company_users"])} {currency}
                            </td>
                            <td style={bodyStyle}>
                              {formatPrice(pricing["accounting_company_documents"])} {currency}
                            </td>
                            <td style={bodyStyle}>
                              {formatPrice(pricing["accounting_company_rossum"])} {currency}
                            </td>
                            <td style={bodyStyle}>
                              {formatPrice(pricing["accounting_company_total"])} {currency}
                            </td>
                          </tr>
                        </tbody>
                        
                      </table>
          </div>

          <div >
            <h2 style={{marginTop: "2rem" }}>Práce s doklady</h2>
            <div style={{ width:"30rem", height:"22rem"}}>
              <div style={{ display: "flex", gap: "2rem"}}>
                <Formik initialValues={{}}>
                  {() => (
                    <Input
                      name="companies"
                      component={AutocompleteSelect}
                      data={companiesWithIds}
                      selectedValue={selectedClientCompanyId}
                      onChange={handleClientCompanySelection}
                      className={styles.input}
                      noBlankOption
                      noErrorPlaceholder
                    />
                  )}
                </Formik>

                <div className={styles.timePeriodWrapper}>
                  {["day", "week", "month"].map((period) => (
                    <label key={period}>
                      <input
                        type="radio"
                        value={period}
                        checked={timePeriod === period}
                        onChange={handleTimePeriodChange}
                      />
                      {period === "day" ? "Dny" : period === "week" ? "Týdny" : "Měsíce"}
                    </label>
                  ))}
                </div>
                
              </div>

              <div className={styles.chartWrapper}>
                <ResponsiveContainer height={350}> 
                  <BarChart data={finalData} margin={{ top: 0, right: 0, left: 0, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" tick={{ fontSize: 12 }} interval="equidistantPreserveEnd" />
                    <YAxis
                      label={{
                        value: "Počet dokladů",
                        angle: -90,
                        position: "insideLeft",
                        offset: 10,
                        style: { textAnchor: "middle", fontSize: 14 },
                      }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                      wrapperStyle={{ height: 40 }}
                      content={({ payload }) => {
                        let filteredPayload = []
                        if (selectedClientCompanyId !== -1){
                          filteredPayload = payload
                        }
                        else{
                          filteredPayload = payload.filter(entry =>
                            finalData.some(dataItem => dataItem[entry.dataKey] && dataItem[entry.dataKey] !== 0)
                          );
                        }
                        
                        return (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr 1fr",
                              gap: "4px 12px",
                              maxHeight: "6rem",
                              overflowY: "auto",
                            }}
                          >
                            {filteredPayload.map((entry, index) => (
                              <div
                                key={`legend-${index}`}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  minWidth: 0,
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: 12,
                                    height: 12,
                                    backgroundColor: entry.color,
                                    marginRight: 6,
                                    borderRadius: 2,
                                    flexShrink: 0,
                                  }}
                                />
                                <span
                                  title={entry.value}
                                  style={{
                                    fontSize: 15,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {entry.value}
                                </span>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    />

                    {selectedClientCompanyId === -1
                      ? filteredCompanies.map((company, idx) => (
                          <Bar
                            key={company.id}
                            dataKey={company.title}
                            stackId="a"
                            fill={colors[idx % colors.length]}
                          />
                        ))
                      : (
                        <>
                          <Bar dataKey="documentsCaptured" fill={colors[0]} name="Vytěženo" />
                          <Bar dataKey="documents" fill={colors[1]} name="Doklady" />
                        </>
                      )}
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            
          </div>
          <div style={{ textAlign: 'right', color:"gray"}}>
            Uvedené částky jsou bez DPH.
          </div>
        </div>
        
      )}
     
    </div>
    
  </div>
);


  
};